import { fetchLocationData } from './api';
import { $, ADDY_API_KEY, AddyComplete } from './consts';
import { displayResults } from './ui';
const addyCallback = (map) => (address) => {
    const lat = parseFloat(address.y);
    const lon = parseFloat(address.x);
    map.setClickMarker(lat, lon);
    map.panToLocation(lat, lon);
    const formattedAddress = address.full || address.displayline;
    $('#address1').val(formattedAddress);
    fetchLocationData(lat, lon).then(displayResults);
};
export function initAddy(map) {
    const formEl = $('#address1');
    const addy = new AddyComplete(ADDY_API_KEY, formEl);
    addy.onPopulate = addyCallback(map);
}
